<template>
    <div class="row dm-editor-profile-content py-4">
        <div class="col-12 col-sm-4 dm-editor-profile-image">
            <div class="ribbon ribbon-right">
                <img :src="editor.profile_image_url" />

                <div
                    class="ribbon-target bg-success dm-profile-ribbon"
                    v-if="editor.open_for_submissions"
                >
                    {{ translate("Taking Submissions") }}
                </div>
                <div class="ribbon-target bg-danger dm-profile-ribbon" v-else>
                    {{ translate("Closed for submissions") }}
                </div>
            </div>

            <div class="dm-social-media">
                <a class="dm-tiktok" :href="editor.tiktok">
                    <i class="icon-lg la la-tiktok"></i>
                </a>

                <a class="dm-facebook" :href="editor.facebook">
                    <i class="icon-lg la la-facebook"></i>
                </a>
                <a class="dm-instagram" :href="editor.instagram">
                    <i class="icon-lg la la-instagram"></i>
                </a>
                <a class="dm-twitter" :href="editor.twitter">
                    <XTwitterSvg class="text-muted" />
                </a>
                <a class="dm-linkedin" :href="editor.website">
                    <i class="icon-lg las la-external-link-alt"></i>
                </a>
            </div>
        </div>
        <div class="col-12 col-sm-8 dm-editor-profile-bio">
            <h1 class="font-weight-bold">{{ editor.name }}</h1>
            <h4 class="mb-4">{{ editor.profile_job }}</h4>

            <div class="pb-0" v-html="editor.profile_bio"></div>

            <h3 class="big mb-4">{{ editor.profile_looking_for_title }}</h3>

            <div v-html="editor.profile_looking_for"></div>

            <div class="dm-editor-back-to-publisher">
                <button
                    class="btn dm-btn-padding dm-btn-brand"
                    @click="selectEditorAndcloseModal()"
                    v-if="editor.open_for_submissions"
                >
                    {{ translate("I want to work with") }} {{ editor.name }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import XTwitterSvg from "@/svg/XTwitterSvg.vue";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState } from "pinia";

export default {
    components: { XTwitterSvg },

    props: ["editor"],

    computed: {
        ...mapWritableState(useSubmissionWizardStore, ["submission"]),
    },

    methods: {
        selectEditorAndcloseModal() {
            this.submission.editor_id = this.editor.id;
            this.hideModals();
        },
    },
};
</script>
